export default __webpack_public_path__ + "static/media/satisfaction.33290ab0.png";